export default __webpack_public_path__ + "static/media/list.64329583.svg";